import {UsersFour, User, BookOpenTextIcon, AddressBookTabsIcon} from '@phosphor-icons/react';

export const CplAdminMenuOptions = [
  {
    name: 'Applicants',
    icon: <UsersFour size={18} color="#212121"/>,
    link: '/cpl-admin'
  },
  {
    name: 'Assigned courses',
    icon: <BookOpenTextIcon size={18} color="#212121"/>,
    link: '/cpl-admin/assigned-courses'
  }
]

export const CplSuperAdminMenuOptions = [
  {
    name: 'Applicants',
    icon: <UsersFour size={18} color="#212121"/>,
    link: '/cpl-admin'
  },
  {
    name: 'Assigned courses',
    icon: <BookOpenTextIcon size={18} color="#212121"/>,
    link: '/cpl-admin/assigned-courses'
  },
  {
    name: 'Create Admin',
    icon: <User size={18} color="#212121"/>,
    link: '/cpl-admin/super-admin/create-admin'
  },
  {
    name: 'All admins',
    icon: <AddressBookTabsIcon size={18} color="#212121"/>,
    link: '/cpl-admin/super-admin/admins-list'
  }
]